import { font } from 'modules/styles';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface PreviewSectionProps extends PropsWithChildren {
    className?: string;
    header: string;
}

const Root = styled.section`
    display: flex;
    flex-direction: column;
`;

const Header = styled.header`
    ${font(14, '#000000', 'semibold')}
    margin-bottom: 12px;
`;

const PreviewSection: FC<PreviewSectionProps> = (props) => {
    const { className, header, children } = props;

    return (
        <Root className={className}>
            <Header>{header}</Header>

            {children}
        </Root>
    );
};

export default PreviewSection;
